/* oxlint-disable @fullscript/gql-file-usage */
// REASON: pre-existing operation file, to be migrated to a .gql file in a follow up MR
import { gql } from "@apollo/client";

const ResendSignInMFAPasscode_Shared_Mutation = gql`
  mutation ResendSignInMFAPasscode_Shared_Mutation(
    $input: AuthUserTwoFactorAuthenticationResendInput!
  ) {
    auth {
      userResendTwoFactorAuthentication(input: $input) {
        sent
        errors {
          message
        }
      }
    }
  }
`;

export { ResendSignInMFAPasscode_Shared_Mutation };
